import React from 'react';
// eslint-disable-next-line no-unused-vars
import { EnhancedDataTableV2 } from 'axp-fx-common';
import { useSelector, useDispatch } from 'react-redux';

const EnhancedDataTableWrapper = React.memo((props) => {
  const fxgApiHost = useSelector((state) => state.getIn(['config', 'fxgApi']));
  const loginData = useSelector((state) => state.getIn([
      'modules',
      'axp-secure-file-express-root',
      'userData',
      'login',
    ])
  );

  return (
    <EnhancedDataTableV2
      {...props}
      loginData={loginData}
      apiHostService={fxgApiHost}
      dispatch={useDispatch()}
    />
  );
});

EnhancedDataTableWrapper.displayName = 'EnhancedDataTableWrapper';

export default EnhancedDataTableWrapper;
